export const ANONYMOUS_GUEST_ID_PLACEHOLDER_PREFIX = 'anonymous_'
